import React from "react";
import { Modal, Button } from "react-bootstrap";

const SalaryDetailModal = ({ show, onHide, salaryapproval }) => {
  if (!salaryapproval) return null;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString("en-IN", options);
  };

  const getApprovedBy = () => {
    if (salaryapproval.approved_by_admin) return "Admin";
    if (salaryapproval.approved_by_clientmanager) return "Client Manager";
    if (salaryapproval.approved_by_superadmin) return "Superadmin";
    return "-";
  };

  const getApprovedName = () => {
    return (
      salaryapproval.approved_by_admin_id?.name ||
      salaryapproval.approved_by_clientmanager_id?.name ||
      salaryapproval.approved_by_superadmin_id?.name ||
      "-"
    );
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Salary Approval Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {salaryapproval.id_user?.name || "N/A"}
        </p>
        <p>
          <strong>Phone Number:</strong>{" "}
          {salaryapproval.id_user?.phonenumber || "N/A"}
        </p>
        <p>
          <strong>Staff Type:</strong>{" "}
          {salaryapproval.id_user?.id_generalStaffType?.name || "N/A"}
        </p>
        <p>
          <strong>Hub:</strong> {salaryapproval.id_hub?.name || "N/A"}
        </p>
        <p>
          <strong>Client:</strong> {salaryapproval.id_client?.name || "N/A"}
        </p>
        <p>
          <strong>Pay Amount:</strong> ₹
          {salaryapproval.pay?.toFixed(2) || "0.00"}
        </p>
        <p>
          <strong>Date:</strong> {formatDate(salaryapproval.date)}
        </p>
        <p>
          <strong>Approved By:</strong> {getApprovedBy()}
        </p>
        <p>
          <strong>Approved Name:</strong> {getApprovedName()}
        </p>
        <p>
          <strong>Status:</strong>{" "}
          <span
            className={`badge fw-bold ${
              salaryapproval.status?.toLowerCase() === "pending"
                ? "bg-danger"
                : "bg-success"
            }`}
          >
            {salaryapproval.status || "-"}
          </span>
        </p>
        <p>
          <strong>Created At:</strong> {formatDate(salaryapproval.createdAt)}
        </p>
        <p>
          <strong>Updated At:</strong> {formatDate(salaryapproval.updatedAt)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SalaryDetailModal;
